import {Route, Routes, BrowserRouter, Navigate} from "react-router-dom";
import Layout from "./layout/Layout"
import Login from "./features/login/Login";
import PasswordReset from "./features/passwordReset/PasswordReset";


import Dashboard from "./features/dashboard/Dashboard";
import ProductPage from "./features/products/ProductPage";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Register from "./features/register/Register";
import PageNotFound from "./components/PageNotFound";
import PrivateRoute from "./components/PrivateRoute";
import {AuthProvider} from "./context/AuthContext";

import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import AuthRoute from "./components/AuthRoute";
import PasswordGuardRoute from "./components/PasswordGuardRoute";
import AddOnProductPage from "./features/addOnProducts/AddOnProductPage";
import ProductGroupPage from "./features/productGroups/ProductGroupPage";
import CustomerPage from "./features/customers/CustomerPage";
import CouponPage from "./features/coupons/CouponPage";
import TransactionPage from "./features/transactions/TransactionPage";
import OrderPage from "./features/orders/OrderPage";
import ShortBill from "./features/orders/ShortBill";
import ShortBillAlignmentTest from "./features/orders/ShortBillAlignmentTest";
import InvoicePage from "./features/invoice/InvoicePage";
import CreditNotePage from "./features/creditNotes/CreditNotePage";
import VerificationEmailSentPage from "./features/register/VerificationEmailSentPage";
import VerifyEmailPage from "./features/verify-email/VerifyEmailPage";
import AccountPage from "./features/account/AccountPage";
import PlansPage from "./features/plans/PlansPage";
import SettingsPage from "./features/settings/SettingsPage";
import PasswordResetEmailSentPage from "./features/passwordReset/PasswordResetEmailSentPage";
import PasswordResetConfirmPage from "./features/passwordReset/PasswordResetConfirmPage";
import CartPageNew from "./features/cart/CartPage";
import RefundPage from "./features/refund/RefundPage";
import WaitingList from "./features/waitingList/WaitingList";
import WaitingListConfirmation from "./features/waitingList/WaitingListConfirmation";
import BillingPage from "./features/billing/BillingPage";
// import BillingPageV2 from "./features/billingv2/BillingPageV2";
import ForcePasswordChangePage from "./features/account/ForcePasswordChangePage";
// import MerchantKYCIndiaPage from "./features/merchantKYCIndia/MerchantKYCIndiaPage";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
})

function App() {

  return (
      <>
          <QueryClientProvider client={queryClient}>
          <BrowserRouter>
              <AuthProvider>
                  <Routes>
                      <Route path='/' element={<PrivateRoute/>}>
                          <Route path='/force-password-change' element={<ForcePasswordChangePage />} />
                          <Route element={<PasswordGuardRoute/>}>
                              <Route element={<Layout/>}>
                                  <Route index element={<Dashboard />} />
                                  <Route path='/sell' element={<Navigate to='/sell/products' />} />
                                  <Route path='/sell/products' element={<ProductPage />} />
                                  <Route path='/sell/add-on-products' element={<AddOnProductPage />} />
                                  <Route path='/sell/product-groups' element={<ProductGroupPage />} />
                                  <Route path='/sell/customers' element={<CustomerPage />} />
                                  <Route path='/sell/coupons' element={<CouponPage />} />
                                  <Route path='/sell/cart' element={<CartPageNew />} />
                                  <Route path='/sell/orders' element={<OrderPage />} />
                                  <Route path='/sell/invoices' element={<InvoicePage />} />
                                  <Route path='/sell/credit-notes' element={<CreditNotePage />} />
                                  <Route path='/sell/refunds' element={<RefundPage />} />
                                  <Route path='/sell/transactions' element={<TransactionPage />} />
                                  <Route path='/account' element={<Navigate to='/account/basic-information' replace />} />
                                  <Route path='/account/plans' element={<PlansPage />} />
                                  <Route path='/account/:tab' element={<AccountPage />} />
                                  <Route path='/settings' element={<Navigate to='/settings/product-settings' replace />} />
                                  <Route path='/settings/:tab' element={<SettingsPage />} />
                                  <Route path='/billing' element={<Navigate to='/billing/overview' replace />} />
                                  <Route path='/billing/:tab' element={<BillingPage />} />
                                  {/* <Route path='/billing-v2' element={<BillingPageV2 />} /> */}
                                  {/*<Route path='/merchant-kyc-india' element={<MerchantKYCIndiaPage />} />*/}
                              </Route>
                              {/* Printable receipt: rendered without the dashboard chrome */}
                              <Route path='/sell/orders/:id/short-bill' element={<ShortBill />} />
                              <Route path='/sell/short-bill-alignment-test' element={<ShortBillAlignmentTest />} />
                          </Route>
                      </Route>
                      <Route path='/' element={<AuthRoute/>}>
                          <Route path='/login' element={<Login />} />
                          <Route path='/reset-password' element={<PasswordReset />} />
                          <Route path='/reset-password-email-sent' element={<PasswordResetEmailSentPage />} />
                          <Route path='/reset-password/:uidb64/:token' element={<PasswordResetConfirmPage />} />
                          <Route path='/register' element={<Register />} />
                          <Route path='/verification-email-sent' element={<VerificationEmailSentPage />} />
                          <Route path='/verify-email/:token' element={<VerifyEmailPage />} />
                          <Route path='/waiting-list' element={<WaitingList />} />
                          <Route path='/waiting-list-confirmation' element={<WaitingListConfirmation />} />
                      </Route>
                      <Route path='*' element={<PageNotFound />}/>
                  </Routes>
              </AuthProvider>

              <ToastContainer theme={"colored"} />
          </BrowserRouter>
              <ReactQueryDevtools />
          </QueryClientProvider>
      </>

  );
}

export default App;
